export const isDevEnvironment = () => {
  const localhostRegexp = /^localhost(:\d+)?$/i;
  const localhostIpRegexp = /^127\.0\.0\.1(:\d+)?$/;
  const playwrightHostRegexp = /^web(:\d+)?$/i;
  const labHostRegexp = /^app\.[a-zA-Z-_]+\.lab(:\d+)?$/i;
  const { host } = window.location;

  return (
    host.endsWith('iconik.cloud') ||
    host.endsWith('iconik.dev') ||
    localhostRegexp.test(host) ||
    localhostIpRegexp.test(host) ||
    playwrightHostRegexp.test(host) ||
    labHostRegexp.test(host)
  );
};
